import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import AppMainRouter from './AppMainRouter';
import AppMainMobileRouter from './AppMainMobileRouter';
import Header from '../sharedComponents/Header/Header';
import { If, Then, Else } from 'react-if';
import { isMobile, isMobileOnly } from 'react-device-detect';
import HeaderLogo from '../sharedComponents/Header/HeaderLogo';
import HeaderLogoLoggedIn from '../sharedComponents/Header/HeaderLogoLoggedIn';
import ProfileSlideDrawer from '../sharedComponents/SlideDrawer/ProfileSlideDrawer';
import HelpSlideDrawer from '../sharedComponents/SlideDrawer/HelpSlideDrawer';
import NotificationsSlideDrawer from '../sharedComponents/SlideDrawer/NotificationsSlideDrawer';
import { AppShell } from '@mantine/core';
import ChangeAppsSlideDrawer from '../sharedComponents/SlideDrawer/ChangeAppsSlideDrawer';
import Logout from './Logout/Logout';
import Chatbot from '../sharedComponents/Chatbot/Chatbot';
import { Theme } from '../config/constants';
import MinimizedChatbot from '../sharedComponents/Chatbot/MinimizedChatbot';

const AppMain = () => {
  const ready = true;
  const isLogin = useSelector(({user}) => user.isLogin);
  const chainData = useSelector(({user}) => user.chainData);
  const emergingData = useSelector(({user}) => user.emergingData);
  const isArrowstream = localStorage.getItem('branding') === 'ARROWSTREAM';
  const isBEP = localStorage.getItem('branding') === 'BEP';
  const salesStreamBotType = (chainData && !emergingData) ? 'salesstream_as' : (emergingData && !chainData) ? 'salesstream_bep' : 'salesstream';

  return (
    <Fragment>
      <If condition={isMobile}>
        <Then>
        <If condition={isLogin}>
          <Then>
            <HeaderLogoLoggedIn logo={process.env.REACT_APP_COMPANY_LOGO_COLOR} />
          </Then>
          <Else>
            <HeaderLogo logo={process.env.REACT_APP_COMPANY_LOGO} />
          </Else>
        </If>
        </Then>
        <Else>
          <ProfileSlideDrawer />
          <HelpSlideDrawer />
          <NotificationsSlideDrawer />
          <ChangeAppsSlideDrawer />
        </Else>
      </If>
      <If condition={ready && isLogin}>
        <Then>
          <If condition={isMobileOnly || isMobile }>
            <Then>
              <AppMainMobileRouter />
            </Then>
            <Else>
              <AppShell
                navbar={{
                  width: 250,
                  breakpoint: 'sm'
                }}
                padding="md"
              >
                <AppShell.Navbar>
                  <Header />
                </AppShell.Navbar>

                <AppShell.Main style={{height: '100vh', paddingTop: '0px'}}>
                  <AppMainRouter />
                </AppShell.Main>
              </AppShell>
            </Else>
          </If>
        </Then>
        <Else>
          <Logout />
        </Else>
      </If>
      {isArrowstream &&
        <Chatbot chatbotType={salesStreamBotType} platform='manufacturer' headerColor={Theme().colors.primary} erniIconBackground={Theme().colors.secondary} showHeaderLogo='false' erniIcon={window.location.origin + process.env.REACT_APP_ARROWSTREAM_ICON} logo={window.location.origin + process.env.REACT_APP_ARROWSTREAM_LOGO}/>
      }
      {isBEP &&
        <Chatbot chatbotType='manufacturer' platform='manufacturer'/>
      }
      <MinimizedChatbot />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLossy
        draggable
        pauseOnHover
      />
    </Fragment>
  );
};

export default AppMain;